import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { CoreService } from 'src/app/shell/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/shell/config';
import { FormsModule } from '@angular/forms';
import { InitService } from 'src/app/shell/services/init.service';
import { CognitoService } from 'src/app/shell/services/cognito.service';
import { jwtDecode } from 'jwt-decode';
import { ManagedLoginService } from 'src/app/shell/services/managed-login.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    FormsModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();

  @Output() toggleCollapsed = new EventEmitter<void>();
  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);

  showFiller = false;
  userEmail: string | null = null;
  userApellido: string | null = null;
  userNombre: string | null = null;
  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private serviceInit: InitService,
    private managedLoginService: ManagedLoginService,
    private router: Router
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    const email = localStorage.getItem('email');
    const apellido = localStorage.getItem('apellido');
    const nombre = localStorage.getItem('nombre');
    if (email && apellido && nombre !== '') {
      this.userEmail = email;
      this.userApellido = apellido;
      this.userNombre = nombre;
      const theme = localStorage.getItem('theme');
      if (theme) {
        this.options.theme = theme;
        this.optionsChange.emit(this.options);
      }
    } else {
      this.managedLoginService.signOut();
    }
  }



  options = this.settings.getOptions();
  setDark() {
    localStorage.setItem('theme', this.options.theme);
    this.optionsChange.emit(this.options);
  }
  public async signOut() {
    this.serviceInit.setEstadoLayout(false);

    try {
      await this.managedLoginService.signOut();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  }
}
